<app-site-header></app-site-header>

<ion-content>
  <app-page-refresher></app-page-refresher>

  <main class="backend-guide-page">
    <aside class="guide-doc-sidebar" [class.menu-open]="isGuideMenuOpen">
      <p class="guide-doc-label">Documentation</p>
      <h1>Safarizine</h1>

      <div class="guide-doc-tools">
        <label class="guide-doc-search">
          <span></span>
          <input
            type="search"
            name="guideSearch"
            [(ngModel)]="guideSearch"
            placeholder="Quick guide"
            (focus)="isGuideMenuOpen = true" />
        </label>

        <button
          type="button"
          class="guide-menu-toggle"
          [attr.aria-expanded]="isGuideMenuOpen"
          aria-controls="backendGuideMenu"
          aria-label="Toggle guide menu"
          (click)="toggleGuideMenu()">
          <ion-icon [name]="isGuideMenuOpen ? 'close-outline' : 'menu-outline'"></ion-icon>
        </button>
      </div>

      <nav id="backendGuideMenu" class="guide-doc-nav" aria-label="Backend guide menu">
        <section *ngFor="let group of filteredNavGroups">
          <h2>{{ group.title }}</h2>
          <button
            type="button"
            *ngFor="let item of group.links"
            [class.active]="item.id === activeSectionId"
            (click)="selectSection(item.id)">
            {{ item.title }}
          </button>
        </section>
      </nav>
    </aside>

    <article class="guide-doc-main">
      <header class="guide-doc-header">
        <h1>Safarizine backend guide</h1>
        <p>
          A customer-friendly walkthrough for managing the ready-made lodge website from the admin panel.
          Follow the menu navigation, update the content, and refresh the app to see changes.
        </p>

        <div class="guide-actions">
          <ion-button [href]="backendUrl" target="_blank" rel="noopener" class="gold-button">
            Open Demo Backend
          </ion-button>
          <ion-button routerLink="/contact" fill="outline">
            Contact Us
          </ion-button>
        </div>

        <div class="guide-stats" aria-label="Backend highlights">
          <article *ngFor="let item of quickStats">
            <strong>{{ item.value }}</strong>
            <span>{{ item.label }}</span>
          </article>
        </div>
      </header>

      <section [id]="activeSection.id" class="guide-doc-section">
        <div class="guide-doc-copy">
          <p class="eyebrow">{{ activeSection.eyebrow }}</p>
          <h2>{{ activeSection.title }}</h2>
          <p>{{ activeSection.intro }}</p>

          <div class="guide-route">
            <span>Menu navigation</span>
            <div class="guide-navigation-list">
              <strong *ngFor="let item of activeSection.navigation; let isLast = last">
                {{ item }}<i *ngIf="!isLast"></i>
              </strong>
            </div>
          </div>

          <h3>Steps</h3>
          <ol class="guide-steps-list">
            <li *ngFor="let step of activeSection.steps">{{ step }}</li>
          </ol>

          <h3>Frontend result</h3>
          <ul class="guide-check-list">
            <li *ngFor="let item of activeSection.outcome">
              <ion-icon name="checkmark-circle-outline"></ion-icon>
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>

        <figure class="guide-screen">
          <figcaption>
            <span>Screenshot {{ activeSectionIndex + 1 }}</span>
            <strong>{{ activeSection.visual.title }}</strong>
          </figcaption>

          <div class="screen-frame">
            <div class="live-screenshot" *ngIf="activeSection.visual.screenshot; else designedScreenshot">
              <button
                type="button"
                class="screenshot-preview-trigger"
                (click)="openScreenshotPreview(activeSection)">
                <img
                  [src]="activeSection.visual.screenshot"
                  [alt]="activeSection.visual.title + ' backend screenshot'"
                  loading="lazy"
                  (error)="hideMissingScreenshot(activeSection)" />
                <span>Tap to preview</span>
              </button>
            </div>

            <ng-template #designedScreenshot>
              <div class="screen-admin">
                <aside>
                  <strong>SAFARIZINE</strong>
                  <span
                    *ngFor="let item of activeSection.visual.menu"
                    [class.active]="item === activeSection.title || item === activeSection.visual.title">
                    {{ item }}
                  </span>
                </aside>

                <div class="screen-panel">
                  <h4>{{ activeSection.visual.title }}</h4>

                  <div *ngIf="activeSection.visual.fields?.length" class="screen-fields">
                    <label *ngFor="let field of activeSection.visual.fields">
                      <span>{{ field }}</span>
                      <i></i>
                    </label>
                  </div>

                  <div *ngIf="activeSection.visual.table?.length" class="screen-table">
                    <div class="screen-table-head">
                      <span *ngFor="let column of activeSection.visual.table">{{ column }}</span>
                    </div>
                    <div class="screen-table-row">
                      <span *ngFor="let column of activeSection.visual.table"></span>
                    </div>
                    <div class="screen-table-row faded">
                      <span *ngFor="let column of activeSection.visual.table"></span>
                    </div>
                  </div>

                  <p *ngIf="activeSection.visual.note" class="screen-note">{{ activeSection.visual.note }}</p>
                </div>
              </div>
            </ng-template>
          </div>
        </figure>
      </section>

      <nav class="guide-article-pager" aria-label="Guide previous and next">
        <button
          type="button"
          class="previous"
          *ngIf="previousSection"
          (click)="selectSection(previousSection.id)">
          <span><ion-icon name="arrow-back-outline"></ion-icon> Previous</span>
          <strong>{{ previousSection.title }}</strong>
        </button>

        <button
          type="button"
          class="next"
          *ngIf="nextSection"
          (click)="selectSection(nextSection.id)">
          <span>Next <ion-icon name="arrow-forward-outline"></ion-icon></span>
          <strong>{{ nextSection.title }}</strong>
        </button>
      </nav>

    </article>
  </main>

  <app-site-footer></app-site-footer>
</ion-content>

<div
  class="screenshot-modal"
  *ngIf="previewScreenshot"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="previewTitle + ' screenshot preview'">
  <button
    type="button"
    class="screenshot-modal-backdrop"
    aria-label="Close screenshot preview"
    (click)="closeScreenshotPreview()"></button>

  <div class="screenshot-modal-panel">
    <header>
      <strong>{{ previewTitle }}</strong>
      <button type="button" aria-label="Close screenshot preview" (click)="closeScreenshotPreview()">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </header>

    <div class="screenshot-modal-image">
      <img [src]="previewScreenshot" [alt]="previewTitle + ' backend screenshot preview'" />
    </div>
  </div>
</div>
